import Converter from "../../../../../functions/Converter";
import { useState, useEffect } from "react";
import { sortCarData } from "./sortedData";


export default function CarContiner ({data, onClick, DataFlightCar, numberCar}) {
    const head = ["שם", "תאריך", "יום", "שעה", "מיקום", "יעד", 'סה"כ', "מסלול", "מחיר"];

    const [dataFilter, setDataFilter] = useState(data);

    useEffect(() => {
        let data2 = sortCarData(data);

        if (DataFlightCar) {
            DataFlightCar = DataFlightCar[1];

            let filter = data2.toSorted((a, b) => {
                if (a[a.length - 1].split(",").includes(DataFlightCar) && !(b[b.length - 1].split(",").includes(DataFlightCar))) {
                    return -1
                } else if (!(a[a.length - 1].split(",").includes(DataFlightCar)) && !(b[b.length - 1].split(",").includes(DataFlightCar))) {
                    return 0
                } else {
                    return 1
                }
            })

            setDataFilter(filter);
        } 

    }, [DataFlightCar, data])

    return (
        <table  className="aufaTable">
            <thead>
                <tr> 
                    {head.map((value, key) => <td key={key}> {value} </td>)} 
                </tr>
            </thead>

            <tbody>
                {
                    dataFilter.map((car, keyCar) => 
                        <tr key={keyCar} onDoubleClick={() => onClick([car[0], ...car.slice(2)])} >
                            {
                                car.slice(2, car.length - 3).map((value, key) => 
                                    <td key={key}> {value} </td>
                                )
                            }

                            <td>
                                <Converter num={car[car.length - 3]} />
                            </td>
                        </tr>
                    )
                }
            </tbody>
        </table>
    )
}